<script setup lang="ts">
  import { useContentsStore } from "~/stores/ContentsStore";
  import { useSnackBarStore } from "~/stores/SnackBarStore";
  interface Props {
    contentId: string;
    isBookmark: boolean;
    clickable: boolean;
    hideBgColor?: boolean;
    iconSize?: number;
  }
  const props = defineProps<Props>();

  const contentsStore = useContentsStore();
  const snackBarStore = useSnackBarStore();
  const isBookmarked = ref<boolean>(props.isBookmark);
  const isBookmarking = ref<boolean>(false);
  const clickableBookmark = computed<boolean>(() => props.clickable && !isBookmarking.value);
  const onClickBookmark = async () => {
    if (!clickableBookmark.value) {
      return;
    }
    isBookmarking.value = true;

    try {
      if (isBookmarked.value) {
        await contentsStore.deleteBookmark(props.contentId);
        snackBarStore.set("ブックマークを削除しました");
      } else {
        await contentsStore.postBookmark(props.contentId);
        snackBarStore.set("ブックマークに追加しました");
      }
      isBookmarked.value = !isBookmarked.value;
    } catch (error: any) {
      snackBarStore.setError("ブックマークの設定に失敗しました");
      sentryErrorLog(`コンテンツブックマークエラー: ${error}`);
    } finally {
      isBookmarking.value = false;
    }
  };

  const computedIconSize = computed<number>(() => {
    return props.iconSize ?? 18;
  });
</script>

<template>
  <div
    class="bookmark-button d-flex"
    :class="[
      isBookmarked ? `bookmarked` : `not-bookmarked `,
      clickable ? 'cursor-pointer' : '',
      hideBgColor ? 'hide-bg-color' : '',
    ]"
    @click.stop.prevent="onClickBookmark"
  >
    <v-icon icon="$mdiBookmark" :size="computedIconSize" />
  </div>
</template>

<style lang="scss" scoped>
  .bookmark-button {
    border-radius: 15px;
    height: 30px;
    padding: 6px 12px;
    font-size: 10px;
    font-weight: 700;
    line-height: 24px; // アイコンがズレるので個別に指定
  }
  .bookmark-count {
    margin-top: -3px;
    margin-left: 8px;
  }
  .bookmarked {
    color: rgb(var(--v-theme-main-01));
    background-color: rgb(var(--v-theme-monochrome-01));
  }
  .not-bookmarked {
    background-color: rgb(var(--v-theme-monochrome-03));
  }
  .hide-bg-color {
    height: 24px;
    padding-top: 4px;
    padding-left: 0px;
    background-color: transparent;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>
